import Id from './Id';
import Name from './Name';
import Customers from './Customers';
import Created from './Created';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  Name: 'Név',
  Customers: 'Vevők',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Customers',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Customers',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Customers,
  Created,
  Updated,
};
